import * as API from "@/api/index.js"
export default {
  data() {
    return {
      zabbix_session:"",
    }
  },
  methods: {
    //zabbix 判断
    is_zabbix(url) {
      if (url.startsWith("/zabbix")  || url.startsWith("/monitor")) {
        return true
      } else {
        return false
      }
    },

    async zabbix_login() {

      if (this.zabbix_is_login) {
        return
      }
      this.loading = true
      const response = await API.POST("/omnis/monitoring_center/monitoring_manage/zabbix_login")
      let data = response.data

      if (data.success) {
        // const response = await API.GET(data.data)
        // let data = response.data
        if (data.success) {
          this.zabbix_session = data.data
        }
        this.zabbix_is_login = true
      }
      this.loading = false


    },
  }
}






// WEBPACK FOOTER //
// ./src/components/common_page/mixin/zabbix.js